import { FC, useState } from "react"
import { Container, Stack, Typography } from "@mui/material"
import { ActiveMailings } from "../components/mailing/activeMailingsTable"
import { FinishedMailings } from "../components/mailing/finishedMailingsTable"
import { useTitle } from "@/core/hooks"

interface IProps {}

export const MailingsPage: FC<IProps> = (props) => {
  const [tab, setTab] = useState(0)
  useTitle(`PR Telegram - Рассылки`)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
  }
  return (
    <Container maxWidth={"xl"}>
      <Stack spacing={3}>
        <Typography variant="h5">Запущенные рассылки</Typography>
        <ActiveMailings />

        <Typography variant="h5">Завершённые рассылки</Typography>
        <FinishedMailings />
      </Stack>
    </Container>
  )
}
